import { zip } from 'lodash-es';

export default zip;
